import { post } from '@alltrails/core/utils/post';
import type { PlaceLocation } from '@alltrails/explore-service/types/ExploreServiceLocation';
import type ExploreServiceResponse from '@alltrails/explore-service/types/ExploreServiceResponse';

export async function getMapBoundsFromSlug(slug: string) {
  return post<ExploreServiceResponse<any>>(`/api/alltrails/explore/v1/search`, {
    resultsToInclude: ['boundingBox'],
    location: { slug }
  });
}

export async function getPlace(location: PlaceLocation) {
  return post<ExploreServiceResponse<any>>(`/api/alltrails/explore/v1/search`, {
    resultsToInclude: ['place'],
    location
  });
}

export async function getNaturalLanguageSearch(query: string, center?: { lat: number; lng: number }) {
  const params = { query };
  if (center) {
    params['location'] = { center, maxRadius: 0 };
  }

  return post<any>(`/api/alltrails/explore-lang/v1/search_request`, params);
}

export async function getBoundingBoxByCenter(center: { lat: number; lng: number }) {
  return post<Pick<ExploreServiceResponse<any>, 'boundingBox'>>(`/api/alltrails/explore/v1/search`, {
    resultsToInclude: ['boundingBox'],
    location: { center }
  });
}
